/*global Cookies*/
(function($){
    $(function(){
      var $notice = $('#zn-privacy-notice');

      if($notice.length){
        var show = true,
            jsCookies = Cookies.noConflict();
  
        if (jsCookies.get('privacyAcceptedUAB')){
          show = false;
        } 
  
        if(show){
          $notice.slideDown('500');
  
          $notice.find('#zn-accept-cookies').on('click', function(){
            jsCookies.set('privacyAcceptedUAB', true, {expires: 365});
            $notice.slideUp('500');
            $(this).off('click');
          });
        }
      }
    });  
  })(jQuery);